<template>
  <div>
    <div class="banner-point">
      <h1>Sucursales</h1>
    </div>
    <div class="grid-container">
      <div class="grid-content">
        <el-row>
          <el-col :span="4">
            <el-select
              v-model="statesNull"
              placeholder="Estado">
              <el-option
                v-for="item in statesMexico"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
            </el-select>
            <br><br>
            <el-select
              v-model="statesNull"
              placeholder="Municipio">
              <el-option
                v-for="item in statesMexico"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
            </el-select>
            <el-button>Limpiar filtros</el-button>
          </el-col>
          <el-col :span="20">2</el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import states from '../_shared/states/states'
export default {
  name: 'PointOfSale',
  data () {
    return {
      statesMexico: states.states,
      statesNull: ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .banner-point{
    margin-top: 70px;
    height: 300px;
    background: url('/static/images/main-banner.jpg') center top no-repeat;
    background-size: cover;
    position: relative;
    h1{
      width: 1280px;
      position: absolute;
      bottom: 30px;
      left: 0;
      right: 0;
      margin: 0 auto;
      color: white;

    }
  }

</style>



// WEBPACK FOOTER //
// src/components/point-of-sale/point-of-sale.vue